import { isEmpty } from "es-toolkit/compat";
import { useRouter } from "next/router";
import { useMemo } from "react";

import { isRunningInIframe, parseIframeUrlPath } from "@moment/ui";

import { useDocumentIdOverride } from "./DocumentIdContext";

export const queryToString = (v: string | string[] | undefined) =>
	Array.isArray(v) ? v.join("/") : (v ?? "");

export const useRouteParams = () => {
	const router = useRouter();
	const override = useDocumentIdOverride();

	return useMemo(() => {
		// If context override is provided, use it instead of router
		if (override) {
			return {
				workspaceName: override.workspaceName ?? "",
				documentId: override.documentId,
				pageSlug: override.pageSlug ?? "",
				path: router.asPath,
			};
		}

		const workspaceName = queryToString(router.query["workspaceName"]);
		const documentId = queryToString(router.query["documentId"]);
		const pageSlug = queryToString(router.query["pageSlug"]);
		const path = router.asPath;

		if (isRunningInIframe()) {
			const params = parseIframeUrlPath(window.location.href);
			return {
				workspaceName: isEmpty(workspaceName) ? params.workspaceName : workspaceName,
				documentId: isEmpty(documentId) ? params.documentId : documentId,
				pageSlug: isEmpty(pageSlug) ? params.pageId : pageSlug,
				path,
			};
		}

		return {
			workspaceName: isEmpty(workspaceName) ? "" : workspaceName,
			documentId: isEmpty(documentId) ? "" : documentId,
			pageSlug: isEmpty(pageSlug) ? "" : pageSlug,
			path,
		};
	}, [router.asPath, router.query, override]);
};
